import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';
import {
 Control,
 Controller,
 FieldErrors,
 UseFormSetValue,
} from 'react-hook-form';

import SelectApi from '../../common/SelectApi';
import { WidgetProductStockProps } from '../Dashboard.types';

interface ProductStockFiltersProps {
 control: Control<WidgetProductStockProps>;
 setValue: UseFormSetValue<WidgetProductStockProps>;
 errors: FieldErrors<WidgetProductStockProps>;
}

const ProductStockFilters: React.FC<ProductStockFiltersProps> = ({
 control,
 setValue,
 errors,
}) => {
 const productFilter = JSON.stringify({ fields: 'Id,Name' });
 const destPointFilter = JSON.stringify({ fields: 'Id,Name' });
 const destPointGroupFilter = JSON.stringify({ fields: 'Id,Name' });

 return (
  <>
   <SelectApi<WidgetProductStockProps>
    name="fromDestPoint"
    url="/api/DestPoint/v1/"
    filter={destPointFilter}
    label="From Dest Point"
    isEditable
    operator="contains"
    control={control}
    setValue={setValue}
   />
   <SelectApi<WidgetProductStockProps>
    name="products"
    url="/api/Products/v2/"
    filter={productFilter}
    label="Products"
    isEditable
    operator="contains"
    control={control}
    setValue={setValue}
   />
   <SelectApi<WidgetProductStockProps>
    name="toDestPoint"
    url="/api/DestPoint/v1/"
    filter={destPointFilter}
    label="To Dest Point"
    isEditable
    operator="contains"
    control={control}
    setValue={setValue}
   />
   <SelectApi<WidgetProductStockProps>
    name="toDestPointGroups"
    url="/api/DestPoint/v1/groups"
    filter={destPointFilter}
    label="Paskirties taškų grupės"
    isEditable
    operator="contains"
    control={control}
    setValue={setValue}
    multiple
   />
   <FormControl fullWidth>
    <InputLabel id="sort-order-label">Sort Order</InputLabel>
    <Controller
     name="sortOrder"
     control={control}
     render={({ field }) => (
      <Select
       {...field}
       labelId="sort-order-label"
       id="sort-order"
       label="Sort Order"
       value={field.value || 'desc'}
      >
       <MenuItem value="desc">Descending</MenuItem>
       <MenuItem value="asc">Ascending</MenuItem>
      </Select>
     )}
    />
   </FormControl>
  </>
 );
};

export default ProductStockFilters;
